import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReportsInitialState } from "./reportsModel";
import { findRMWiseReport } from "./services/reports.services";

const initialState: IReportsInitialState = {
  loading: false,
  error: "",
  RelationshipManagerReportList: [],
  RelationshipManagerReportDetails: {
    RelationManagerID: null,
  },
};

export const ReportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    clearRelationshipManagerReportList: (state) => {
      state.RelationshipManagerReportList =
        initialState.RelationshipManagerReportList;
    },
    clearRelationshipManagerReportDetails: (state) => {
      state.RelationshipManagerReportDetails =
        initialState.RelationshipManagerReportDetails;
    },
    setRelationshipManagerDetail: (state, action) => {
      state.RelationshipManagerReportDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findRMWiseReport.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findRMWiseReport.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.RelationshipManagerReportList = action.payload;
      }
    );
    builder.addCase(findRMWiseReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.RelationshipManagerReportList = [];
    });
  },
});

export const {
  clearRelationshipManagerReportList,
  setRelationshipManagerDetail,
  clearRelationshipManagerReportDetails,
} = ReportsSlice.actions;
export default ReportsSlice.reducer;
